<template>
  <app-collapsible-section class="date-picker-drawer">
    <template v-slot:header-content>
      <h5
        class="picker-title"
        :style="globalTheme.colorDark">
        <app-inline-svg
          class="_mrxs"
          :src="labels.monthlySvgIcon.url"
          :style="globalTheme.colorPrimary"/>
        {{labels.monthlyAvailability}}
      </h5>
    </template>
    <div grid="row wrap">
      <div
        v-if="labels.monthlyAvailabilityInfoContent"
        column="xs-12 s-12 xl-5">
        <div
          class="_mbxs"
          v-html="labels.monthlyAvailabilityInfoContent"></div>
      </div>
      <div :column="labels.monthlyAvailabilityInfoContent ? 'xs-12 s-12 xl-7' : 'xs-12 s-12 xl-8 +xl-2'">
        <div aria-live="polite" class="sr-only">
          {{ currentMonthYear }}
        </div>
        <VDatePicker expanded
        :attributes="selectedDate"
          mode="single"
          :model-value="selectedDate" 
          :key="calendarKey"
          :locale="`${$route.params.lang}`"
          :class="{disabled: fetchingExams}"
          :min-date="minDate"
          class="calendar-date-picker"
          color="gray"
          is-inline
          @update:model-value="newValue => selectedDate = newValue"
          @did-move="handleMonthChange"
          /> 
      </div>
    </div>
  </app-collapsible-section>
</template>
<script lang="ts">
   import {defineComponent} from 'vue'
  import { ScheduleADateLabels } from '@/types'
  import 'v-calendar/style.css';
  export default defineComponent({
    components: {
  },
  data() {
    return {
      attributes: [
        {
           highlight: true,
        },
      ],
      currentMonthYear: null as string|null|undefined,
    };
  },
    props: {
      modelValue: {
        required: true,
        type: Date
      },
      minDate: {
        required: true,
        type: Date
      },
      labels: {
        required: true,
        type: Object as ()=> ScheduleADateLabels
      },
      fetchingExams: {
        type: Boolean,
        default: false
      },
      calendarKey: {
        type: Number,
        default:0
      }
    },
    methods: {
      addAriaLabels() {
        const nextArrow = document.querySelector('.vc-arrow.vc-next');
        const prevArrow = document.querySelector('.vc-arrow.vc-prev');        
        if (nextArrow) nextArrow.setAttribute('aria-label', 'Next month');
        if (prevArrow) prevArrow.setAttribute('aria-label', 'Previous month');
      },
      announceCurrentMonth() {
       setTimeout(() => {
        const current = document.querySelector('.vc-title')?.firstElementChild?.textContent;
        if (current) {
          this.currentMonthYear = current;
        }
      }, 0);
      },
      handleMonthChange() {
        this.announceCurrentMonth()
      },
    },
    computed: {
      selectedDate: {
        get(): Date {
          return this.modelValue
        },
        set(newVal: Date) {
         if (this.fetchingExams || !newVal) return;
          this.$emit('update:modelValue', newVal)
        }
      }
    },
    mounted(){
      this.addAriaLabels();
      this.handleMonthChange()
    },
  })
</script>
<style>
.vc-container.calendar-date-picker {
  width:100%;
}
.vc-focus:focus, .vc-focus:focus-within {
  outline: 2px solid #007bff;
  outline-offset: 1px; 
}
</style>
